import React from 'react';
import { toastr } from 'react-redux-toastr';
import Modal from '../../commons/modal/modal';
import Attachments from '../../commons/attachments/attachments';
import { downloadBulkAppointmentSample } from './ceTaskboardRedux/ceTaskboardActionCreator';
import styles from './ceTaskboard.scss';

const downloadLogo = require('../../../assets/images/download-symbol.svg');

class BulkUploadModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      errors: []
    };
    this.onFileUpload = this.onFileUpload.bind(this);
  }

  onClose() {
    this.props.closeModal();
    this.removeAttachedFile();
  }

  onFileUpload(errors) {
    if (errors && errors.length) {
      this.setState({ file: null, errors });
    } else {
      if (this.props.source === 'addressFloorTagging') {
        this.onClose();
        return;
      }
      toastr.success('Success', 'Bulk upload successful.');
      this.onClose();
    }
  }

  setUploadFilesSelected(file) {
    this.setState({ file });
  }

  removeAttachedFile() {
    this.setState({ file: null, errors: [] });
  }

  render() {
    const { source } = this.props;
    return (
      <Modal
        showModal={this.props.showModal}
        title="Bulk Upload Appointment"
        closeModal={() => this.onClose()}
      >
        <div className={`l-col ${styles.modalContentWrapper}`}>
          <div>
            <div className=" l-row">
              <div className={`flex-100 ${styles.downloadWrapper}`}>
                <div
                  className={`l-row ${styles.downloadAction}`}
                  onClick={() => {
                    if (
                      source === 'addressFloorTagging' &&
                      this.props.downloadExcel
                    ) {
                      this.props.downloadExcel();
                    } else {
                      downloadBulkAppointmentSample();
                    }
                  }}
                >
                  <img
                    src={downloadLogo}
                    alt="Download"
                    className={styles.downloadIcon}
                  />
                  <div className={styles.text}>Download Sample</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-100" style={{ marginTop: '2rem' }}>
            <div className=" l-row">
              <Attachments
                attachmentFor="consignment_appointment_bulk"
                heading={
                  source === 'addressFloorTagging'
                    ? 'Upload Sheet'
                    : 'Upload Appointment Sheet'
                }
                setUploadFilesSelected={file =>
                  this.setUploadFilesSelected(file)
                }
                removeAttachedFile={() => this.removeAttachedFile()}
                loadedFileName={
                  this.state.file &&
                  this.state.file[0] &&
                  this.state.file[0].name
                }
                accept=".xlsx, .xls, .csv"
                attachmentModalWrapper={`flex-100  ${styles.attachmentModalWrapper}`}
                dropzoneWrapperStyle={`a-center ${styles.dropzoneWrapperStyle}`}
                textDialogWrapperStyle="flex-100  j-center a-center"
                fileNameWrapper={styles.fileNameWrapper}
                crossButtonWrapper={styles.crossButtonWrapper}
              />
            </div>
            {this.state.errors && !!this.state.errors.length && (
              <div className={styles.errorTable}>
                <div className={styles.errorHeader}>
                  Uploading errors ({this.state.errors.length} CNs not updated)
                </div>
                <div className={`l-row ${styles.errorTableHeader}`}>
                  <div className="flex-30">Cnote</div>
                  <div className="flex-70">Error</div>
                </div>
                <div>
                  {this.state.errors.map(error => (
                    <div className={`l-row ${styles.errorTableRow}`}>
                      <div className="flex-30">{error.cnote}</div>
                      <div className="flex-70">{error.status}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="l-row j-end a-end">
            <div
              className={`${styles.submitBtnWrapper} l-row j-center a-center`}
              onClick={() =>
                this.props.bulkUploadAppointment(
                  this.state.file && this.state.file[0],
                  this.onFileUpload
                )
              }
            >
              SUBMIT
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default BulkUploadModal;
